/* @flow */

import React from 'react';
import { Button } from 'reactstrap';
// import cx from 'classnames';

import FaMagic from 'react-icons/lib/fa/magic';
// import FaRotateLeft from 'react-icons/lib/fa/rotate-left';
import FaChevronCircleLeft from 'react-icons/lib/fa/chevron-circle-left';
import FaChevronCircleRight from 'react-icons/lib/fa/chevron-circle-right';
// import FaRepeat from 'react-icons/lib/fa/repeat';
import FaRefresh from 'react-icons/lib/fa/refresh';

// import classes from './RightToolBar.scss';

type PropsType = {
  disableAutoComplete: boolean,
  disableBack: boolean,
  disableNext: boolean,
  disableReset: boolean,
  disableUndo: boolean,
  onAutoComplete: Function,
  onStepBackward: Function,
  onStepForward: Function,
  onStepReset: Function,
  onUndo: Function,
};

export class RightToolBar extends React.PureComponent<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const {
      disableAutoComplete, onAutoComplete, disableReset,
      onStepReset, disableBack, onStepBackward,
      disableNext, onStepForward,
    } = this.props;

    return (
      <ul className="nav ml-auto">
        {
        // <Button color="secondary" size="sm" disabled={!props.enableUndo} onClick={props.onUndo}>
        //   <FaRotateLeft style={{ color: '#0EADF8' }} /> Undo
        // </Button>
        // <Button color="secondary" size="sm" disabled={!props.enableRedo} onClick={props.onRedo}>
        //   Redo <FaRepeat style={{ color: '#0EADF8' }} />
        // </Button>
        }
        <li className="nav-item">
          <Button color="secondary" size="sm" disabled={disableAutoComplete} onClick={onAutoComplete}>
            <FaMagic style={{ color: '#0EADF8' }} /> Auto-Complete
          </Button>
        </li>
        <li className="nav-item">
          <Button color="secondary" size="sm" disabled={disableReset} onClick={onStepReset}>
            <FaRefresh style={{ color: '#FA9300' }} /> Reset
          </Button>
        </li>
        <li className="nav-item">
          <Button color="secondary" size="sm" disabled={disableBack} onClick={onStepBackward}>
            <FaChevronCircleLeft /> Back
          </Button>
        </li>
        <li className="nav-item">
          <Button color="secondary" size="sm" disabled={disableNext} onClick={onStepForward}>
            Next <FaChevronCircleRight />
          </Button>
        </li>
      </ul>
    );
  }
}

export default RightToolBar;



// WEBPACK FOOTER //
// ./src/components/RightToolBar/RightToolBar.js